import { render } from "./PasswordChange.vue?vue&type=template&id=260c7702&scoped=true"
import script from "./PasswordChange.js?vue&type=script&lang=js&external"
export * from "./PasswordChange.js?vue&type=script&lang=js&external"

import "./PasswordChange.scss?vue&type=style&index=0&id=260c7702&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260c7702"]])

export default __exports__